import { initializeI18N } from '@if/core/i18n';
export const initializeSharedI18N = () => initializeI18N(['shared']);
